var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbridgeFavicon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 101,
    viewBox: "0 0 176 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_6335_3071)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.29 52.6566C164.017 56.2922 164.881 59.9733 164.881 63.6998C164.881 67.3354 163.972 70.971 162.154 74.6066C160.336 78.1513 157.382 81.3324 153.292 84.15C149.202 86.8767 143.976 88.24 137.614 88.24H136.796C136.25 88.3309 135.705 88.3764 135.16 88.3764H80.3529C77.8988 88.2855 75.8083 87.422 74.0814 85.786C72.4454 84.0591 71.582 81.9686 71.4911 79.5146V38.7851L89.8963 38.7505H130.524C132.251 38.6596 133.705 38.2506 134.887 37.5234C135.978 36.8872 136.796 36.1601 137.341 35.3421C137.886 34.4332 138.159 33.5243 138.159 32.6154C138.159 31.7065 137.886 30.843 137.341 30.025C136.796 29.1161 135.932 28.3436 134.751 27.7073C133.66 26.9802 132.251 26.5712 130.524 26.4803H93.7137H71.4911V17.0732C71.582 14.6192 72.4454 12.5741 74.0814 10.9381C75.8083 9.21122 77.8988 8.30232 80.3529 8.21143H127.252C127.797 8.21143 128.343 8.25687 128.888 8.34776H129.706C136.068 8.52954 141.295 9.98378 145.385 12.7105C149.475 15.4372 152.429 18.5729 154.246 22.1176C156.064 25.5714 156.973 29.0707 156.973 32.6154C156.973 36.251 156.11 39.7957 154.383 43.2495C154.292 43.4313 154.201 43.5676 154.11 43.6585C157.837 46.2943 160.563 49.2937 162.29 52.6566ZM138.432 70.1075C140.158 70.1984 141.567 69.8803 142.658 69.1532C143.84 68.426 144.703 67.608 145.248 66.6991C145.794 65.6993 146.066 64.6996 146.066 63.6998C146.066 63.0635 145.794 62.2001 145.248 61.1094C144.703 59.9278 143.84 58.9735 142.658 58.2464C141.567 57.5192 140.158 57.1102 138.432 57.0193H89.8963V66.4265C89.8963 68.8805 91.1688 70.1075 93.7137 70.1075H138.432Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.6126 38.8868C29.6124 35.7056 31.2484 32.8881 33.5207 30.434C35.8838 27.98 38.7923 26.6621 42.2461 26.4803H66.6774V17.0732C66.6774 13.7547 67.6993 11.9555 68.5805 10.8759C69.4618 9.79623 70.3054 8.88265 72.0062 8.21143H37.4744C32.839 8.30232 28.7035 9.75656 25.0679 12.5741C21.5232 15.3917 18.6602 18.8001 16.4788 22.7993C14.3884 26.7075 12.8432 30.843 11.8434 35.2057C10.8436 39.5685 10.3438 43.9766 10.3438 48.4302C10.3438 54.429 11.2072 60.2914 12.9341 66.0175C14.7519 71.7435 17.7058 76.8788 21.7959 81.4233C25.8859 85.8769 31.1121 88.0128 37.4744 88.3764H87.2367C89.7816 88.3764 91.963 87.831 93.7808 86.195C95.5986 84.4681 96.5529 82.3322 96.6438 79.7873C96.0985 74.0612 92.9628 70.9255 87.2367 70.3802H42.2461C38.7923 70.1984 35.8838 68.9259 33.5207 66.5628C31.1576 64.1088 29.4761 61.2912 28.4763 58.11C27.5674 54.9289 27.113 51.7023 27.113 48.4302C27.113 45.1582 27.6128 41.9771 28.6126 38.8868ZM80.3529 8.21143C77.8988 8.30232 75.8083 9.21122 74.0814 10.9381C72.4454 12.5741 71.582 14.6192 71.4911 17.0732V26.4803H87.2367C89.7816 26.4803 91.963 25.6623 93.7808 24.0263C95.6895 22.2994 96.6438 20.1635 96.6438 17.6185C96.0985 11.8925 92.9628 8.75677 87.2367 8.21143H80.3529Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_6335_3071",
    x: -0.000390053,
    y: 0.0000982285,
    width: 175.223,
    height: 100.853,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.13281
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.17207
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6335_3071"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6335_3071",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2.13281
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.06641
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.57 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_6335_3071"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbridgeFavicon2);
export default __webpack_public_path__ + "static/media/cashbridgeFavicon2.09298b61182ae7403531c19a89675cd9.svg";
export { ForwardRef as ReactComponent };